
import axios, { AxiosError } from 'axios';
import { LocalStorage } from 'quasar'
import { api } from 'src/boot/axios';
import { computed, ComputedRef, reactive } from 'vue';
import emitter from './emitter';
import { Answer } from './models';


interface AuthInfo {
  token: string
  user: unknown
  state: Record<string, unknown>
}

export class User{
  readonly id!: number
  readonly name!: string

  constructor(data: unknown) {
    Object.assign(this, data)
  }
}

const authInfo = reactive<AuthInfo>({ token: '', user: undefined, state: {} })


const user = computed(() => {
  const data = authInfo.user as Record<string, unknown>;
  if (isLoggedIn()) {
    return new User(data)
  } else {
    return undefined
  }
})


function getStorageKey() {
  const key = 'mukhda-auth'
  if (!key) {
    throw new Error('No storage key found')
  }
  return key
}

export const isLoggedIn = () => {
  return !!authInfo.user
}

export function currentUser() {
  return user.value
}


export const login = (token: string, user: unknown) => {
  authInfo.token = token
  authInfo.user = user
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  // api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  LocalStorage.set(getStorageKey(), authInfo)
  emitter.emit('login', authInfo.user)
}


export const logout = () => {
  Object.keys(authInfo).forEach(k => delete (authInfo as Record<string, unknown>)[k])
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  delete api.defaults.headers.common['Authorization'];
  LocalStorage.remove(getStorageKey())
  emitter.emit('logout')
}

function enableAutoLogout() {
  api.interceptors.response.use(res => res, (err: AxiosError) => {
    if (err.response?.status == 401) {
      logout()
    }
    return Promise.reject(err)
  })
}


export function initialize() {
  const info: Record<string, unknown> = LocalStorage.getItem(getStorageKey()) ?? {};
  authInfo.token = info.token as string ?? ''
  authInfo.user = info.user ?? undefined
  enableAutoLogout()
}

export async function loadCurrentUser(url: string) {
  if (!isLoggedIn()) {
    return
  }
  try {
    const resp = (await api.get(url)).data as User
    authInfo.user = resp
  } catch (e) {
    if (axios.isAxiosError(e) && (e.response?.status == 401 || e.response?.status == 403)) {
      logout()
    }
    console.log('Failed to fetch current user details', e)
  }
}

export function setCurrentUser(user: unknown) {
  if (!isLoggedIn()) {
    return
  }
  authInfo.user = user
}

export function useCurrentUser<T>() {
  return user as unknown as ComputedRef<T>
}

